import React from "react";

import { Divider, SettingsPageSubtitle, SettingsPageTitle } from "./shared";
import { UserApiKeysSection } from "./UserApiKeysSection";

import styles from "./DeveloperTools.module.css";

export default function DeveloperTools() {
	return (
		<div className={styles.main}>
			<SettingsPageTitle>Developer tools</SettingsPageTitle>
			<SettingsPageSubtitle>
				Build your own tools with Fellow’s REST API.{" "}
				<a href="https://help.fellow.app/en/articles/11817206-api" target="_blank" rel="noopener noreferrer">
					Learn more here.
				</a>
			</SettingsPageSubtitle>
			<Divider />
			<UserApiKeysSection enabled />
		</div>
	);
}
